import { crudService } from '../_services';
import alerts from '../_components/alerts';
import { analisesAction } from '../_actions';
import { stringUtils } from '../_utils';
import axios from 'axios';
import { authHeader } from '../_helpers';


export const relatoriosAction = {
    getRelatorioAnalises,
    getRelatorioAnalisesExcel
};

function getRelatorioAnalises(filterModel, props) {
    return dispatch => {
        alerts.waiting();

        const apiEndpoint =
            'relatorios/relatorioAnalises' +
            stringUtils.serialize(filterModel);

        crudService.get(apiEndpoint)
            .then(response => {
                if (response.data) {
                    dispatch(
                        analisesAction.changeAnalisesList(response.data, 1)
                    );
                    alerts.clean();
                    props.history.push({
                        pathname: "/relatorioAnalises",
                        state: { data: response.data }
                    });
                }
            })
            .catch(err => {
                console.error(err);
                alerts.error(err);
            });
    };
}

function getRelatorioAnalisesExcel(filterModel) {
    return dispatch => {
        alerts.waiting();

        axios.post(
            '/api/relatorios/analisesCompletoExcel',
            filterModel,
            {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            }
        )
            .then(response => {
                const blob = new Blob(
                    [response.data],
                    { type: 'text/csv;charset=utf-8;' }
                );

                const data = new Date()
                    .toLocaleDateString('pt-BR')
                    .replaceAll('/', '-');

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `relatorioAnalises_${data}.csv`;
                link.click();

                alerts.clean();
            })
            .catch(err => {
                console.error(err);
                alerts.error('Erro ao gerar Excel');
            });
    };
}